import React from 'react';

const JSON_Parse = () => {
  return (
    <div >
      <h1>JSON_Parse</h1>
      <p>Placeholder component for: "JSON Parse"</p>
    </div>
  );
};

export default JSON_Parse;
